import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { StorageService } from './storage.service';

const SYS_PREFERENCES_VER = '1.0';
const SYS_PREFERENCES_KEY = 'SYS_PREFERENCES_USER';
const SYS_GLOBAL_KEY = 'SYS_PREFERENCES_GLOBAL';
const SYS_PREFERENCE_USERID_DEFAULT = 'DEFAULT';

@Injectable()
export class PreferencesService {

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private storageService: StorageService
    ) {
        this.storage = this.storageService.storage;
        // this.testHashCollision();
    }

    private storage: any;

    private keyMap: any = {
        'expandListDetails': 'a',
        'expandSearchConditions': 'b',
        'pageSize': 'c',
        'userGuideState': 'e',
        'colConfig': 'f',
        'stronghold': 'g',
        'lang': 'l',
        'local': 'n'
    };

    private isInit = false;
    private isUserInit = {};
    private _userId;
    public get userId() {
        if (!this._userId) {
            const json = sessionStorage.getItem('userInfo');
            if (json) {
                try {
                    this._userId = JSON.parse(json).loginName;
                } catch (error) {
                    this._userId = SYS_PREFERENCE_USERID_DEFAULT;
                }
            }
        }
        return this._userId;
    }
    public set userId(val) {
        if (this._userId !== val) {
            this._userId = val;
            this.initUser();
        }
    }

    private get preferenceKey() { return `${SYS_PREFERENCES_KEY}-${SYS_PREFERENCES_VER}-${this.userId}`; }
    private get globalKey() { return `${SYS_GLOBAL_KEY}-${SYS_PREFERENCES_VER}`; }

    // 用户偏好集合
    private preferences: any;
    // 全局偏好集合
    private global: any;

    private async initGlobal() {
        await this.storage.getItem(this.globalKey).then((value) => {
            this.global = value;
            if (!this.global) {
                this.global = {};
                this.storage.setItem(this.globalKey, this.global);
            }
            this.isInit = true;
        });
    }

    private async initUser() {
        await this.storage.getItem(this.preferenceKey).then((value) => {
            this.preferences = value;
            if (!this.preferences) {
                this.preferences = {};
                this.storage.setItem(this.preferenceKey, this.preferences);
            }
            this.isUserInit[this.userId] = true;
        });
    }

    // 页面路由地址过长,使用hash做为key.(Djb2)
    private hash(text: string) {
        let hash = 5381,
            index = text.length;
        while (index) {
            hash = (hash * 33) ^ text.charCodeAt(--index);
        }
        return (hash >>> 0).toString(16);
    }

    private removeUrlParams(url) {
        const index = url.indexOf('?');
        if (index >= 0) {
            return url.substr(0, index);
        }
        return url;
    }

    // 生成hashKey
    private getHashKey(isGlobal: boolean) {
        // 使用页面路由做为页面标识
        const path = isGlobal ? 'global' : this.removeUrlParams(this.router.url);
        let hashKey;
        if (environment.production) {
            hashKey = this.hash(path);
        } else {
            hashKey = path + '_' + this.hash(path);
        }
        const pref = isGlobal ? this.global : this.preferences;
        if (pref[hashKey] === undefined) {
            pref[hashKey] = {};
        }
        return hashKey;
    }

    // 测试hash冲突，新增路由时最好测试一下。
    private testHashCollision() {
        const hash = this.hash;
        const arr = [], obj = {}, arrCollision = [];
        this.router.config.forEach((item) => {
            const originalPath = item.path;
            arr.push(originalPath);
            if (obj[hash(originalPath)] === 1) {
                arrCollision.push(originalPath);
            } else {
                obj[hash(originalPath)] = 1;
            }
        });
        console.log('"Test Hash Collision": ', arrCollision.length > 0 ? 'faild' : 'passed');
        if (arrCollision.length > 0) {
            console.table(arrCollision);
        }
    }

    /**
     * 获取偏好
     * @param string  prop
     * @param boolean isGlobal 是否全局偏好(true:多用户/多页面共享;false:单用户/按路由路径存储)
     * @returns Promise value | undefined
     */
    async get(prop: string, isGlobal: boolean = false) {
        if (prop.trim() === '') {
            throw new Error('Missing or invalid argument passed to preferences.get()');
        }
        if (isGlobal && !this.isInit) {
            await this.initGlobal();
        } else if (!isGlobal && !this.isUserInit.hasOwnProperty(this.userId)) {
            await this.initUser();
        }
        const hashKey = this.getHashKey(isGlobal);
        const key = this.keyMap[prop] || prop;
        const pref = isGlobal ? this.global : this.preferences;
        return pref[hashKey][key];
    }

    /**
     * 保存偏好
     * @param string  prop
     * @param any     value
     * @param boolean isGlobal 是否全局偏好，用于公共模块，不会按页面记录偏好。
     * @returns promise true|false
     */
    async set(prop: string, value, isGlobal: boolean = false) {
        if (prop.trim() === '') {
            throw new Error('Missing or invalid argument passed to preferences.set()');
        }
        let result = false;
        const hashKey = this.getHashKey(isGlobal);
        const key = this.keyMap[prop] || prop;
        if (key !== undefined) {
            const pref = isGlobal ? this.global : this.preferences;
            const prefKey = isGlobal ? this.globalKey : this.preferenceKey;
            pref[hashKey][key] = value;
            await this.storage.setItem(prefKey, pref).then(() => {
                result = true;
            });
        }
        return result;
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/preferences.service.ts